import PropTypes from 'prop-types';
import React from 'react';
import capitalize from 'lodash/string/capitalize';

import Button from '@xanadu/ui-shared/components/widgets/Button';
import styles from './ConfirmAction.module.scss';

export default function ConfirmAction({
  action,
  onDismiss,
  onAccept,
  onUpdate,
  offersLength
}) {
  const title = 'Review Order';
  let question;
  let titleButton;

  if (offersLength > 1) {
    titleButton = `${capitalize(action)} ${offersLength} bets`;
    question = `Are you sure you want to ${action} ${offersLength} bets?`;
  } else {
    titleButton = `${capitalize(action)} Bet`;
    question = `Are you sure you want to ${action} ${offersLength} bet?`;
  }

  return (
    <div className={styles.confirmAction}>
      <div className={styles.title}>{title}</div>
      <div className={styles.question}>{question}</div>
      <div className={styles.actions}>
        <div className={styles.actionsContainer}>
          <Button
            sizeType="regular"
            buttonType="flat"
            className={styles.button}
            onClick={() => onDismiss()}
            title="Cancel"
          >Cancel</Button>
          <Button
            sizeType="regular"
            buttonType="primary"
            className={styles.button}
            title={titleButton}
            onClick={() => {
              onDismiss();
              onAccept();
            }}
          >{titleButton}</Button>
        </div>
        <div className={styles.reminder}>
          <input type="checkbox" onClick={e => onUpdate(!e.target.checked)} />
          <span>{"Don't ask me again"}</span>
        </div>
      </div>
    </div>
  );
}

ConfirmAction.propTypes = {
  action: PropTypes.string,
  onDismiss: PropTypes.func,
  onAccept: PropTypes.func,
  onUpdate: PropTypes.func,
  offersLength: PropTypes.number
};
